import * as React from 'react';
import { IPerson, IMedia, IGenre } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import { Redirect } from 'react-router';
import { NavLink } from 'react-router-dom';
import Favorite from '../components/parts/Favorite';
import { transliterate } from '../utils/functions';
import Track from '../components/items/Track';
import { withTranslation } from 'react-i18next';
import i18n from '../config/i18next';
import Banner from '../components/parts/Banner';

interface IState {
    person: IPerson,
    isLoading: boolean,
    name: string,
    person_id: number,
    isNotFound: boolean,
    tracks: IMedia[],
    clips: IMedia[],
    albums: IMedia[],
    genres: IGenre[]
}

class SingerView extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            person: null,
            isLoading: true,
            name: this.props.match.params.name,
            person_id: this.props.match.params.person_id,
            isNotFound: false,
            tracks: [],
            clips: [],
            albums: [],
            genres: []
        };
    }

    componentWillReceiveProps(props: any) {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "auto"
        });

        this.setState({
            name: props.match.params.name,
            person_id: props.match.params.person_id,
            isLoading: true,
        }, this.componentDidMount);
    }

    async componentDidMount() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/singer/view?person_id=${this.state.person_id}`);

        if (!this._isUnmounted)
            if (response.data.status == "success") {
                this.setState({
                    person: response.data.person,
                    tracks: response.data.tracks,
                    clips: response.data.clips,
                    albums: response.data.albums,
                    genres: response.data.genres,
                    isLoading: false,
                });
            } else {
                this.setState({
                    isNotFound: true
                });
            }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const {t} = this.props;

        return (
            <div className="i-body">
                {this.state.isNotFound && <Redirect to="/not-found" />}
                <div className="container v-index">
                    <div className="wrapper" style={{paddingBottom: "20px"}}>

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}

                        {!this.state.isLoading && (<div className="wrap wrap-s">
                            <h4 className="pull-left">{this.state.person.full}</h4>
                            <div className="clearfix"></div>
                            <div className="row">
                                <div className="col-md-3 col-sm-4">
                                    <a href={this.state.person.fullpath} data-lightbox="image-1" data-title={this.state.person.full}>
                                        <img className="img-responsive" style={{ marginBottom: "10px" }} src={this.state.person.fullpath} alt={this.state.person.full} />
                                    </a>
                                </div>
                                <div className="col-md-5 col-sm-7" style={{ marginBottom: "15px" }}>
                                    <span style={{ padding: "5px", fontSize: "18px" }}>
                                        {t("Клипы")}: <a className="text-underline" onClick={() => {
                                            document.getElementById("clips").scrollIntoView();
                                        }}>{this.state.clips.length}</a>
                                    </span>
                                   
                                    <br />
                                   
                                    <span style={{ padding: "5px", fontSize: "18px" }}>
                                        {t("Треки")}: <a className="text-underline" onClick={() => {
                                            document.getElementById("tracks").scrollIntoView();
                                        }}>{this.state.tracks.length}</a>
                                    </span>
                                   
                                    <br />
                                   
                                    <span style={{ padding: "5px", fontSize: "18px" }}>
                                        {t("Альбомы")}: <a className="text-underline" onClick={() => {
                                            document.getElementById("albums").scrollIntoView();
                                        }}>{this.state.albums.length}</a>
                                    </span>
                                   
                                    <br />
                                    
                                    {this.state.genres.length > 0 && <span style={{ padding: "5px", fontSize: "18px" }}>
                                        {t("Жанр")}: <span> </span>
                                        {this.state.genres.map((genre: IGenre, index: number) => {
                                            return <span key={index}>
                                                <NavLink className="text-underline" to={"/music/" + genre.genre_id}>{genre.name}</NavLink>
                                                {this.state.genres.length - 1 != index && " / "}
                                            </span>
                                        })}
                                    </span>}
                                </div>
                                <div className="col-md-4 col-sm-5">
                                    <Banner place={34} className="banner235" style={{ marginTop: 0 }}/>
                                </div>
                            </div>

                            <div className="box_list clips_list" id="clips">
                                <h5>{t("Клипы")}</h5>
                                {!this.state.isLoading && this.state.clips.length == 0 && <h4 className="fs-16 mt-10">{t("Ничего не найдено")}</h4>}
                                {!this.state.isLoading && this.state.clips.length > 0 && <div className="row w-unset">
                                    {this.state.clips.map((clip: IMedia, index: number) => {
                                        return (
                                            <div className="col-md-3 col-sm-6 col-xs-6" key={index}>
                                                <div className="item">
                                                    <div className="img_box">
                                                        <div className="icons">
                                                            <ul>
                                                                <li>
                                                                    <Favorite media={clip} />
                                                                </li>
                                                                <li>
                                                                    <span> </span>
                                                                    <NavLink to={"/clip/" + transliterate(clip.artist.full + "-" + clip.name) + "/" + clip.media_id}>
                                                                        <i className="fa fa-play-circle-o"></i>
                                                                    </NavLink>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <img style={{ width: "100%", height: "100%" }} src={clip.fullFirstFrame} alt={clip.name} />
                                                    </div>
                                                    <div className="clearfix"></div>
                                                   
                                                    <NavLink style={{ whiteSpace: "nowrap", marginTop: "10px" }} to={"/clip/" + transliterate(clip.name) + "/" + clip.media_id} className="title" title={clip.name}>
                                                        {clip.name}
                                                    </NavLink>
                                                </div>
                                            </div>
                                        );
                                    })}

                                </div>}
                            </div>

                            <div className="music_box tracks_list" id="tracks">
                                <h5>{t("Треки")}</h5>
                                {!this.state.isLoading && this.state.tracks.length == 0 && <h4 className="fs-16 mt-10">{t("Ничего не найдено")}</h4>}
                                {!this.state.isLoading && this.state.tracks.length > 0 && <ul className="row singer-tracks">
                                    {this.state.tracks.map((track: IMedia, index: number) => {
                                        return <Track key={index} className="col-md-6" style={{ padding: "15px" }} hideArtist track={track} />
                                    })}
                                </ul>}
                            </div>

                            <div className="box_list clips_list albums_list" id="albums">
                                <h5>{t("Альбомы")}</h5>
                                {!this.state.isLoading && this.state.albums.length == 0 && <h4 className="fs-16 mt-10">{t("Ничего не найдено")}</h4>}
                                <div className="row">
                                    {!this.state.isLoading && this.state.albums.map((track: IMedia, index: number) => {
                                        return (
                                            <div key={index} className="col-md-3 col-sm-6 col-xs-6">
                                                <div className="item">
                                                    <div className="img_box" style={{ borderRadius: 0 }}>
                                                        <div className="icons">
                                                            <ul>
                                                                <li>
                                                                    <Favorite media={track} />
                                                                </li>
                                                                <li>
                                                                    <span> </span>
                                                                    <NavLink to={"/album/" + transliterate((track.artist ? track.artist.full : "") + "-" + track.name) + "/" + track.media_id}>
                                                                        <i className="fa fa-play-circle-o"></i>
                                                                    </NavLink>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <img style={{ width: "100%", height: "100%" }} src={track.fullImage} alt={track.name} />
                                                    </div>
                                                    <div className="clearfix"></div>
                                                    
                                                    <NavLink style={{ whiteSpace: "nowrap" }} to={"/album/" + transliterate(track.name) + "/" + track.media_id} className="title" title={track.name}>
                                                        {track.name}
                                                    </NavLink>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>)}

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(SingerView);